import Label from '../../../ui/Label'
import Input from '../../../ui/Input'
import { CreateClientRequest } from '../../../../types/client';

interface ClientModalInputWrapProps {
    label: string;
    value: string;
    handleChange: (field: keyof CreateClientRequest, value: string) => void;
    typeOfAction: 'newClient' | 'update'
    type: string;
    placeholder: string;
    field: keyof CreateClientRequest;
    maxLength?: number;
    required?: boolean;
}

export default function ClientModalInputWrap({ label, value, handleChange, typeOfAction, type, placeholder, field, maxLength, required }: ClientModalInputWrapProps) {
    return (
        <div className=''>
            <Label label={label} />
            <Input
                type={type}
                value={value}
                onChange={(e) => {
                    handleChange(field, e.target.value)
                }}
                placeholder={placeholder}
                required={required}
                disabled={typeOfAction === 'update'}
                maxLength={maxLength}
            />
        </div>
    )
}
